import { initI18n } from './initI18n';

export const i18n = initI18n();
